<template>
  <div id="customer-list">
    <div class="add-btn-box">
      <el-button type="primary" @click="addCustomer">新增项目</el-button>
    </div>
    <div
      class="alarm-table"
      v-loading="loading"
      element-loading-text="加载中..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <el-table :data="tableList" style="width: 100%">
        <el-table-column prop="name" label="项目名称" align="center">
        </el-table-column>
        <el-table-column prop="shortName" label="简称" align="center">
        </el-table-column>
        <el-table-column prop="code" label="代码" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center" width="240">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      background
      :current-page="pagination.currentPage"
      layout="prev, pager, next"
      :total="pagination.total"
      @current-change="pageChange"
    >
    </el-pagination>
    <!-- 弹窗新增编辑 -->
    <base-dialog
      :title='dialogTitle'
      size="small"
      :visible.sync="dialogTableVisibles"
      v-if="dialogTableVisibles"
      @close="resetForm('ruleForm')"
      width="80%"
    >
      <el-form
        :model="ruleForm"
        ref="ProjectForm"
        label-width="100px"
        class="custom-ruleForm"
        size="small "
      >
        <el-form-item
          label="项目名称"
          prop="name"
          :rules="{
            required: true,
            message: '项目名称不能为空',
            trigger: 'blur',
          }"
        >
          <el-input :maxlength="20" v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item
          label="简称"
          prop="shortName"
          :rules="{ required: true, message: '简称不能为空', trigger: 'blur' }"
        >
          <el-input :maxlength="20" v-model="ruleForm.shortName"></el-input>
        </el-form-item>
        <el-form-item
          label="代码"
          prop="code"
          :rules="{ required: true, message: '代码不能为空', trigger: 'blur' }"
        >
          <el-input :maxlength="20" v-model="ruleForm.code"></el-input>
        </el-form-item>
        <el-form-item
          label="客户"
          prop="customerId"
          :rules="{
            required: true,
            message: '客户不能为空',
            trigger: 'change',
          }"
        >
          <el-select
            v-model="ruleForm.customerId"
            placeholder="请选择客户"
            :disabled="dialogState === 'edit'"
          >
            <el-option
              v-for="item in customerList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="产品"
          prop="productId"
          :rules="{
            required: true,
            message: '产品不能为空',
            trigger: 'change',
          }"
        >
          <el-select
            v-model="ruleForm.productId"
            placeholder="请选择产品"
            :disabled="dialogState === 'edit'"
          >
            <el-option
              v-for="item in productList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="服务里程"
          prop="mileage"
          :rules="{
            required: true,
            message: '服务里程不能为空',
            trigger: 'blur',
          }"
        >
          <el-input :maxlength="7" v-model.number="ruleForm.mileage"></el-input>
        </el-form-item>
        <el-form-item
          label="收费站数量"
          prop="station"
          :rules="{
            required: true,
            message: '收费站数量不能为空',
            trigger: 'blur',
          }"
        >
          <el-input :maxlength="7" v-model.number="ruleForm.station"></el-input>
        </el-form-item>
        <el-form-item
          label="位置（省）"
          prop="provinceId"
          :rules="{
            required: true,
            message: '省份信息不能为空',
            trigger: 'change',
          }"
        >
          <el-select v-model="ruleForm.provinceId" @change="provinceChange" placeholder="请选择省份">
            <el-option
              v-for="item in provinceOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="位置（市）"
          prop="cityId"
          :rules="{
            required: true,
            message: '市级信息不能为空',
            trigger: 'change',
          }"
        >
          <el-select v-model="ruleForm.cityId" @change="cityChange" placeholder="请选择城市">
            <el-option
              v-for="item in cityOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="handleBtn">
          <el-button type="primary" @click="submitForm('ProjectForm')"
            >保存</el-button
          >
          <el-button @click="resetForm('ProjectForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </base-dialog>
  </div>
</template>

<script>
import BaseDialog from '@/components/BaseDialog.vue'
import {
  getProductslist,
  deleteProject,
  saveProject,
  getlistDictByType,
  projectDetail,
  updateProject,
  getCustomlist,
  getProductlist,
} from './service'
export default {
  name: 'CustomerList',
  components: {
    BaseDialog,
  },
  data () {
    return {
      dialogTitle: '',
      dialogTableVisibles: false,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      dialogState: 'add',
      loading: false,
      tableList: [],
      projectId: '', // 当前项目id
      areaList: [],
      productList: [], // 产品列表
      customerList: [], // 客户列表
      ruleForm: {
        name: '',
        shortName: '',
        code: '',
        customerId: '',
        productId: '',
        mileage: null,
        station: null,
        provinceId: '',
        cityId: '',
      },
      provinceOptions: [],
      cityOptions: [],
    }
  },
  computed: {},
  mounted () {
    // 获取项目列表
    this.getProjects()
    // 获取区域列表
    this.getlistDictType()
    // 获取客户
    this.getCusList()
    // 获取产品
    this.getProList()
  },
  created () {
    this.getProvinceData()
  },
  methods: {
    // 省份选择change事件
    provinceChange (e) {
      this.ruleForm.provinceId = e
      this.$http.get('/rest/base/area/dropDownList', {
        pid: e,
      }).then(res => {
        if (res.code === 0) {
          this.cityOptions = res.data
        } else {
          this.$message({
            type: 'error',
            message: '市级数据获取失败',
          })
        }
      })
    },
    // 市级change事件
    cityChange (e) {
      this.ruleForm.cityId = e
    },
    // 获取省级区域下拉列表
    getProvinceData () {
      this.$http.get('/rest/base/area/dropDownList', {
        level: 1,
      }).then(res => {
        if (res.code === 0) {
          this.provinceOptions = res.data
        } else {
          this.$message({
            type: 'error',
            message: '省份数据获取失败',
          })
        }
      })
    },
    // 编辑项目
    handleEdit (index, row) {
      this.projectId = row.id
      this.getprojectDetail(row.id)
      this.dialogState = 'edit'
      this.dialogTitle = '编辑'
    },
    // 删除项目
    handleDelete (index, row) {
      this.$confirm('确定删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await deleteProject(row.id)
          if (res.code === 0) {
            this.$message.success({ message: '操作成功', duration: 1500 })
            this.pagination.currentPage = 1
            this.getProjects()
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    // 新建用户弹窗关闭
    resetForm (formName) {
      this.ruleForm.name = ''
      this.ruleForm.shortName = ''
      this.ruleForm.code = ''
      this.ruleForm.customerId = ''
      this.ruleForm.productId = ''
      this.ruleForm.mileage = null
      this.ruleForm.station = null
      this.ruleForm.provinceId = ''
      this.ruleForm.cityId = ''
      this.$refs.ProjectForm.clearValidate()
      this.dialogTableVisibles = false
    },
    // 新增项目事件
    addCustomer () {
      this.dialogState = 'add'
      this.dialogTableVisibles = true
      // this.$refs.ProjectForm.clearValidate();
      // this.resetForm('ruleForm')
      this.dialogTitle = '新增'
    },
    /**
     * @description:   分页改变事件
     * @param {Number} currPage  当前页码
     * @return {*}
     */
    pageChange (currPage) {
      this.pagination.currentPage = currPage
      this.getProjects()
    },
    // 获取项目详情
    async getprojectDetail (id) {
      const res = await projectDetail(id)
      this.dialogTableVisibles = true
      console.log(res)
      this.ruleForm = res.data
      console.log(this.ruleForm)
    },
    // 获取项目列表分页
    async getProjects () {
      const params = {
        pageNo: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      }
      const res = await getProductslist(params)
      this.tableList = res.data.list
      this.pagination.total = Number(res.data.total)
    },
    // 获取大区列表
    async getlistDictType () {
      const params = {
        type: 2,
      }
      const res = await getlistDictByType(params)
      this.areaList = res.data
    },
    // 获取客户
    async getCusList () {
      const res = await getCustomlist()
      this.customerList = res.data
    },
    // 获取产品
    async getProList () {
      const res = await getProductlist()
      this.productList = res.data
    },
    // 新建项目
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.dialogState === 'add') {
            this.savePro()
          } else {
            this.updatePro()
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 保存项目信息
    async savePro () {
      console.log(this.ruleForm)
      const params = {
        name: this.ruleForm.name,
        shortName: this.ruleForm.shortName,
        code: this.ruleForm.code,
        customerId: this.ruleForm.customerId,
        productId: this.ruleForm.productId,
        mileage: this.ruleForm.mileage,
        station: this.ruleForm.station,
        provinceId: this.ruleForm.provinceId,
        cityId: this.ruleForm.cityId,
      }
      const res = await saveProject(params)
      if (res.code === 0) {
        this.$message.success({ message: '操作成功', duration: 1000 })
        this.dialogTableVisibles = false
        this.getProjects()
        this.resetForm()
      } else {
        this.$message.error({ message: res.msg })
        // this.dialogTableVisibles = false
      }
    },
    // 更新项目信息
    async updatePro () {
      const params = {
        name: this.ruleForm.name,
        shortName: this.ruleForm.shortName,
        code: this.ruleForm.code,
        customerId: this.ruleForm.customerId,
        productId: this.ruleForm.productId,
        mileage: this.ruleForm.mileage,
        station: this.ruleForm.station,
        provinceId: this.ruleForm.provinceId,
        cityId: this.ruleForm.cityId,
        id: this.projectId,
      }
      const res = await updateProject(params)
      if (res.code === 0) {
        this.$message.success({ message: '操作成功', duration: 1000 })
        this.dialogTableVisibles = false
        this.getProjects()
        this.resetForm()
      } else {
        this.$message.error({ message: res.msg })
        // this.dialogTableVisibles = false
      }
    },
  },
}
</script>

<style lang="less" scoped>
#customer-list {
  position: relative;
  .alarm-table {
    margin-top: 60px;
  }
  .add-btn-box {
    position: absolute;
    right: 60px;
    top: -38px;
    z-index: 1;
  }

  .custom-ruleForm {
    margin: 10px 30px;
    .el-form-item {
      margin-bottom: 15px;
    }
  }
  .handleBtn {
    position: absolute;
    right: 20px;
    bottom: 0;
  }
}
</style>
<style >
</style>
